import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import MediationProcessTemplate from './mediation-process-template-model'
import {
  CreateMediationProcessTemplateAsync,
  DeleteMediationProcessTemplateAsync,
  LoadMediationProcessTemplatesAsync,
} from './mediationProcessTemplate-thunk'
const initialState: mediationProcessTemplateSliceState = {
  mediationProcessTemplate: [],
  selected_mediationProcessTemplate: '',
  is_loading_mediationProcessTemplate: false,
  is_creating_mediationProcessTemplate: false,
  is_deleting_mediationProcessTemplate: false,
}
export interface mediationProcessTemplateSliceState {
  mediationProcessTemplate: MediationProcessTemplate[]
  selected_mediationProcessTemplate?: string
  is_loading_mediationProcessTemplate: boolean
  is_creating_mediationProcessTemplate: boolean
  is_deleting_mediationProcessTemplate: boolean
}
export const mediationProcessTemplateSlice = createSlice({
  name: 'mediationProcessTemplate',
  initialState,
  reducers: {
    setSelectedmediationProcessTemplate: (state, action) => {
      state.selected_mediationProcessTemplate = action.payload
    },
    clearStatemediationProcessTemplate: (state) => {
      state.mediationProcessTemplate = []
      state.is_loading_mediationProcessTemplate = false
      state.is_creating_mediationProcessTemplate = false
      state.is_deleting_mediationProcessTemplate = false
    },
    mergemediationProcessTemplate: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_mediationProcessTemplate = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.mediationProcessTemplate = merge(
            state.mediationProcessTemplate,
            payload,
          ) as any
        }
      }
    },

    add_mediationProcessTemplate: (state, action) => {
      if (action.payload) {
        state.mediationProcessTemplate = [
          ...state.mediationProcessTemplate,
          action.payload,
        ]
      }
    },
    set_mediationProcessTemplate: (state, action) => {
      let { key, value, id } = action.payload
      state.mediationProcessTemplate = state.mediationProcessTemplate.map(
        (item) => {
          if (item && item.id === id) {
            return {
              ...item,
              [key]: value,
            }
          }
          return item
        },
      )
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMediationProcessTemplatesAsync.pending, (state) => {
      state.is_loading_mediationProcessTemplate = true
    })
    builder.addCase(
      LoadMediationProcessTemplatesAsync.fulfilled,
      (state, action) => {
        state.is_loading_mediationProcessTemplate = false
        if (action.payload) {
          state.mediationProcessTemplate = action.payload
        }
      },
    )
    builder.addCase(LoadMediationProcessTemplatesAsync.rejected, (state) => {
      state.is_loading_mediationProcessTemplate = false
    })
    builder.addCase(CreateMediationProcessTemplateAsync.pending, (state) => {
      state.is_creating_mediationProcessTemplate = true
    })
    builder.addCase(CreateMediationProcessTemplateAsync.fulfilled, (state) => {
      state.is_creating_mediationProcessTemplate = false
    })
    builder.addCase(CreateMediationProcessTemplateAsync.rejected, (state) => {
      state.is_creating_mediationProcessTemplate = false
    })
    builder.addCase(DeleteMediationProcessTemplateAsync.pending, (state) => {
      state.is_deleting_mediationProcessTemplate = true
    })
    builder.addCase(
      DeleteMediationProcessTemplateAsync.fulfilled,
      (state, action) => {
        state.is_deleting_mediationProcessTemplate = false
        if (state.mediationProcessTemplate) {
          state.mediationProcessTemplate =
            state.mediationProcessTemplate.filter(
              (x) => action.payload.id !== x.id,
            )
        }
      },
    )
    builder.addCase(DeleteMediationProcessTemplateAsync.rejected, (state) => {
      state.is_deleting_mediationProcessTemplate = false
    })
  },
})

export const {
  clearStatemediationProcessTemplate,
  setSelectedmediationProcessTemplate,
  set_mediationProcessTemplate,
  mergemediationProcessTemplate,
  add_mediationProcessTemplate,
} = mediationProcessTemplateSlice.actions

export const get_mediationProcessTemplate =
  (id?: string) =>
  (state: {
    mediationProcessTemplate: {
      mediationProcessTemplate: MediationProcessTemplate[]
    }
  }): MediationProcessTemplate | null => {
    let temp = state?.mediationProcessTemplate?.mediationProcessTemplate?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.mediationProcessTemplate?.mediationProcessTemplate[0] || null
  }
export const get_selected_mediationProcessTemplate = (state: {
  mediationProcessTemplate: mediationProcessTemplateSliceState
}): MediationProcessTemplate | null => {
  let id = state?.mediationProcessTemplate?.selected_mediationProcessTemplate
  let temp = state?.mediationProcessTemplate?.mediationProcessTemplate?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_mediationProcessTemplate = (state: {
  mediationProcessTemplate: {
    mediationProcessTemplate: MediationProcessTemplate[]
  }
}): MediationProcessTemplate[] => {
  let temp = state?.mediationProcessTemplate?.mediationProcessTemplate
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_mediationProcessTemplate_busy = (state: {
  mediationProcessTemplate: mediationProcessTemplateSliceState
}) => {
  return (
    state?.mediationProcessTemplate.is_deleting_mediationProcessTemplate ||
    state?.mediationProcessTemplate.is_loading_mediationProcessTemplate ||
    state?.mediationProcessTemplate.is_creating_mediationProcessTemplate
  )
}
export const is_deleting_mediationProcessTemplate_busy = (state: {
  mediationProcessTemplate: mediationProcessTemplateSliceState
}) => {
  return state?.mediationProcessTemplate.is_deleting_mediationProcessTemplate
}
export const is_loading_mediationProcessTemplate_busy = (state: {
  mediationProcessTemplate: mediationProcessTemplateSliceState
}) => {
  return state?.mediationProcessTemplate.is_loading_mediationProcessTemplate
}
export const is_creating_mediationProcessTemplate_busy = (state: {
  mediationProcessTemplate: mediationProcessTemplateSliceState
}) => {
  return state?.mediationProcessTemplate.is_creating_mediationProcessTemplate
}

export default mediationProcessTemplateSlice.reducer
